import React from "react";
import Navbar from "../Navbar";
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import { ArrowForwardOutlined, BusinessOutlined, LocationOnOutlined, PeopleOutlineOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export const LandingPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSetup = () => {
     navigate("/auth/signup/setup-company");
  }

  return (
    <>
      <Navbar pageType="SIGNUP" />
      <Stack mt={20}>
        <Typography
          variant="h1"
          color="primary.main"
          fontSize={"4rem"}
          fontWeight={600}
          textAlign={"center"}
        >
          Welcome to Your Platform
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.grey[600],
            fontSize: "1.5rem",
            textAlign: "center",
            mb: 5
          }}
        >
          Set up your company, venue, and team in minutes with our streamlined
          onboarding process
        </Typography>
        <Stack p={3}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={1.5}></Grid>
                 <Grid item xs={12} md={3}>
                    <Card 
                        heading="Banquets Setup"
                        subHeading="Create your banquet profile with logo and details"
                        icon={<BusinessOutlined/>}
                    />
                 </Grid>
                 <Grid item xs={12} md={3}>
                    <Card 
                        heading="Venue Management"
                        subHeading="Add and manage your venue"
                        icon={<LocationOnOutlined/>}
                    />
                 </Grid>
                 <Grid item xs={12} md={3}>
                    <Card 
                        heading="User Profiles"
                        subHeading="Complete user registration and setup"
                        icon={<PeopleOutlineOutlined/>}
                    />
                 </Grid>
                     <Grid item xs={12} md={1.5}></Grid>
            </Grid>
             
        </Stack>
        <Stack mt={3}>
            <Button variant="contained" color="primary" size="large"
            endIcon={<ArrowForwardOutlined/>}
            sx={{px: 5, py: 1.5, fontSize: "1.2rem", alignSelf: "center"}}
            onClick={handleSetup}
            >Get Started</Button>
        </Stack>
      </Stack>
    </>
  );
};


const Card: React.FC<{heading: string, subHeading: string, icon: React.ReactNode}> = ({
    heading,
    subHeading,
    icon
}) => {
    const theme = useTheme();

    return(
        <Stack sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "20px",
            backgroundColor: '#fff',
            p: 4,
            height: "100%",
        }}>
            <Box sx={{
                "& svg": {
                    fontSize: "5rem",
                    color: theme.palette.primary.main
                },
                display: "flex",
                justifyContent: "center",
                mb: 2
            }}>
                {icon}
            </Box>
            <Typography
                variant="h3"
                color="primary.main"
                fontSize={"1.6rem"}
                fontWeight={600}
                textAlign={"center"}
                mb={1}
            >
                {heading}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: theme.palette.grey[600],
                    fontSize: "1.2rem",
                    textAlign: "center",
                }}
            >
                {subHeading}
            </Typography>

        </Stack>
    )
}